export default "__VITE_ASSET__BHF4HlWQ__"